// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VersionStatus = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
} as const;
export type VersionStatus = typeof VersionStatus[keyof typeof VersionStatus];


export function instanceOfVersionStatus(value: any): boolean {
    for (const key in VersionStatus) {
        if (Object.prototype.hasOwnProperty.call(VersionStatus, key)) {
            if (VersionStatus[key as keyof typeof VersionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VersionStatusFromJSON(json: any): VersionStatus {
    return VersionStatusFromJSONTyped(json, false);
}

export function VersionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionStatus {
    return json as VersionStatus;
}

export function VersionStatusToJSON(value?: VersionStatus | null): any {
    return value as any;
}

export function VersionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): VersionStatus {
    return value as VersionStatus;
}
